/**
 * MSAL Instance Initializer
 * Creates and initializes the PublicClientApplication instance
 */

import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfiguration } from './msalConfig.js';

let msalInstance = null;
let initPromise = null;

export function getMsalInstance() {
  if (!msalInstance) {
    msalInstance = new PublicClientApplication(msalConfiguration);
  }
  return msalInstance;
}

export async function initializeMsal() {
  if (!initPromise) {
    const instance = getMsalInstance();
    initPromise = instance.initialize().then(async () => {
      try {
        const result = await instance.handleRedirectPromise();
        if (result?.account) {
          instance.setActiveAccount(result.account);
        } else {
          const accounts = instance.getAllAccounts();
          if (accounts.length > 0 && !instance.getActiveAccount()) {
            instance.setActiveAccount(accounts[0]);
          }
        }
        if (result?.state && result.state.startsWith('/')) {
          sessionStorage.removeItem('auth_redirect');
          window.location.replace(result.state);
        }
      } catch (err) {
        console.error('Error handling MSAL redirect promise:', err);
      }
      return instance;
    });
  }
  return initPromise;
}
